import {Feature} from '@myparcel-frontend/iam-service';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';

export const useOrderVersion = () => {
  const {isIamFeatureActive} = useServiceAccount();
  const hasOrderManagement = isIamFeatureActive(Feature.ORDER_MANAGEMENT);
  const hasLegacyOrderManagement = isIamFeatureActive(Feature.LEGACY_ORDER_MANAGEMENT);

  return {
    hasOrderManagement,
    hasLegacyOrderManagement,
    hasOrderAccess: hasOrderManagement || hasLegacyOrderManagement,
  };
};
